import {
    ChevronRightMedium,
    PropertyManagementMedium,
} from '@zoopla-eng/zds-components/icons';
import {
    chevronStyle,
    contentStyle,
    iconWrapperStyle,
    miniHeadingStyle,
    miniMojoLogoStyle,
    miniPartnershipStyle,
    miniWrapperStyle,
} from './MojoMiniCTA.styles.css';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import { MojoLogo } from '@zoopla/assets';

export const MINI_MOJO_HEADING = 'Free remortgage advice';
export const PARTNERSHIP_TEXT = 'In partnership with';

export const MojoMiniCTA = () => {
    return (
        <div className={miniWrapperStyle}>
            <div className={iconWrapperStyle}>
                <PropertyManagementMedium color="buttonPrimaryTextDefault" />
            </div>
            <div className={contentStyle}>
                <h2 className={`${fontGroups.ladle} ${miniHeadingStyle}`}>
                    {MINI_MOJO_HEADING}
                </h2>
            </div>

            <p className={`${fontGroups.spoon} ${miniPartnershipStyle}`}>
                {PARTNERSHIP_TEXT}
                <MojoLogo className={miniMojoLogoStyle} />
            </p>
            <div className={chevronStyle}>
                <ChevronRightMedium />
            </div>
        </div>
    );
};
